import React from 'react'
import { Dropdown, Button, Menu, Icon, Select } from 'antd'
import './styles.scss'

const Option = Select.Option;

export default ({access_control, onChange, disabled }) =>{
  let access_controls = [
      'private',
      'public-read',
      'public-read-write',
      'aws-exec-read',
      'authenticated-read',
      'bucket-owner-read',
      'bucket-owner-full-control'
  ]

  return (
    <div className='access-controls center-child indicator'>
      <div className='content small-size'>
        <span>Access Control:</span>

        <div className='select-box'>
          {/*<Select defaultValue="private" onChange={(e)=> onChange(e.key)} disabled={disabled}>
            {
              access_controls.map(function(access_control){return <Option key={access_control}>{access_control}</Option>})
            }
          </Select>*/}


          <Dropdown disabled={disabled} size={'small'} overlay={
            <Menu onClick={(e)=> onChange(e.key)}>{
              access_controls.map(function(access_control){return <Menu.Item key={access_control}>{access_control}</Menu.Item>})
            }
            </Menu>
          }>

            <Button className='dropdown-thumb'>
              {access_control} <Icon type='down'/>
            </Button>
          </Dropdown>
        </div>

      </div>
    </div>
  )
}

